export default __webpack_public_path__ + "static/media/JohannaLovelace.89e15d32.png";